import type React from 'react';

import type { SmartCardProvider } from '@atlaskit/link-provider';

export type SmartCardProviderProduct = React.ComponentProps<typeof SmartCardProvider>['product'];

const CONTEXT_PRODUCT_TO_SMART_CARD_PRODUCT: Partial<
	Record<string, NonNullable<SmartCardProviderProduct>>
> = {
	atlas: 'ATLAS',
	bitbucket: 'BITBUCKET',
	confluence: 'CONFLUENCE',
	csm: 'CSM',
	elevate: 'ELEVATE',
	jira: 'JSW',
	'jira-product-discovery': 'JPD',
	'jira-service-management': 'JSM',
	'jira-software': 'JSW',
	'jira-work-management': 'JWM',
	jpd: 'JPD',
	jsm: 'JSM',
	jsw: 'JSW',
	jwm: 'JWM',
	trello: 'TRELLO',
};

export const getSmartCardProviderProduct = (product?: string): SmartCardProviderProduct => {
	if (!product) {
		return undefined;
	}

	const normalizedProduct = product
		.trim()
		.toLowerCase()
		.replace(/[\s_]+/g, '-');

	return CONTEXT_PRODUCT_TO_SMART_CARD_PRODUCT[normalizedProduct];
};
